export default __webpack_public_path__ + "static/media/expl_015_EN.0f6aa1ce.png";